import type {
	MemberReview,
	MemberReviewComment,
	MemberReviewPhoto,
} from '@api/graphql/reviews/getReviewsForMember';
import type { Comment, ReviewWeddingVendorsReview } from 'types/api/reviews';
import type { Gallery } from 'types/reviews';

export const mapGetReviewsForMember = (reviews: MemberReview[]) => {
	return reviews.map((review) => mapReview(review));
};

function mapReview(review: MemberReview): ReviewWeddingVendorsReview {
	const storefrontId =
		review.reviewees[0]?.storefrontId || '00000000-0000-0000-0000-000000000000';
	const comments = review.comment ? [mapComment(review.comment)] : [];

	return {
		id: review.id,
		profileGuid: storefrontId,
		title: '',
		reviewer: {
			id: review.reviewer.memberId || '',
			firstName: review.reviewer.firstName || '',
			lastName: review.reviewer.lastName || '',
			userName: '',
			role: review.reviewer.role || 'bride',
			weddingDate: review.attributes?.weddingDate || '',
			memberDate: '',
		},
		content: review.content,
		rating: review.overallRating || 0,
		createdDate: review.createdAt,
		modifiedDate: review.updatedAt,
		isFavorite: false,
		isTestimonial: review.highlighted,
		active: true,
		comments,
		commentCount: comments.length,
		gallery: mapPhotos(review.photos),
		isUserVerified: review.userVerified,
		budget: {
			cost:
				review.attributes?.budgetCost === undefined
					? null
					: review.attributes?.budgetCost,
			guestCount:
				review.attributes?.budgetGuestCount === undefined
					? null
					: review.attributes?.budgetGuestCount,
		},
		isVendorDisputed: review.disputed || false,
		disputedReviewStatus: review?.dispute?.status || null,
	};
}

function mapComment(comment: MemberReviewComment): Comment {
	return {
		id: comment.id,
		text: comment.content,
		createdDate: comment.createdAt,
		modifiedDate: comment.updatedAt,
		commenterId: comment.commenterId,
		commenterUserName: '',
		commenterFirstName: '',
		commenterLastName: '',
		commenterRole: '',
	};
}

function mapPhotos(photos: MemberReviewPhoto[]): Gallery[] {
	return photos
		.sort((a, b) => (b.sortOrder || 0) - (a.sortOrder || 0))
		.reduce<Gallery[]>((acc, photo) => {
			if (!photo.active) return acc;
			const mappedPhoto: Gallery = {
				typeCode: 'PHOTO' as const,
				sourceId: photo.sourceId || '',
				active: photo.active,
				name: photo.name || '',
				width: photo.width || 0,
				height: photo.height || 0,
				id: photo.id,
				source: {
					application: 'theknot',
				},
				timestamp: {
					createdAt: photo.createdAt,
					updatedAt: photo.updatedAt,
				},
			};

			acc.push(mappedPhoto);
			return acc;
		}, []);
}
